import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import GlobalSettingsComponent from './global-settings.component';

export const GlobalsSettingsComponent = ({ handleInnerFormChange, selectGlobalSettings, handleFormSubmit, isSubmitting }: any) => {

  const tabItems = [
    {
      id: 1,
      title: 'Global Settings',
      component: <GlobalSettingsComponent
        selectGlobalSettings={selectGlobalSettings}
        handleInnerFormChange={handleInnerFormChange}
      />,
      isVisible: true,
    }
  ];

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

      <TabContainer tabItems={tabItems} />

      <div className="flex w-full justify-end items-end">
        <button
          type="submit"
          onClick={handleFormSubmit}
          disabled={isSubmitting}
          className="my-4 px-6 py-2 bg-blue-600 text-white rounded-lg disabled:opacity-50 flex items-center"
        >
          {isSubmitting ? (
            <>
              <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
              Saving...
            </>
          ) : (
            "Save"
          )}
        </button>
      </div>
    </div>
  );
};

export default GlobalsSettingsComponent;
